import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const HeroSection = () => {
  return (
    <div className="relative bg-slate-800 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1588607629573-04988bd726f1?auto=format&fit=crop&q=80&w=2000" 
          alt="Rugged lawn care" 
          className="w-full h-full object-cover opacity-40 mix-blend-overlay"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/80 to-transparent"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="inline-flex items-center space-x-2 bg-green-700 text-white px-3 py-1 rounded-sm font-bold text-sm mb-6 uppercase tracking-wider">
            <SafeIcon icon={FiIcons.FiBatteryCharging} />
            <span>Zero Gas. Zero Emissions.</span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight uppercase tracking-tighter mb-6">
            Dominate <br/>
            <span className="text-lime-400">Your Yard.</span>
          </h1>
          <p className="text-xl text-gray-300 mb-10 font-medium">
            Commercial-grade electric power. Built for the toughest overgrowth. Powered by the VoltYard universal battery system.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <button className="bg-lime-400 hover:bg-lime-500 text-slate-900 font-bold py-4 px-8 rounded-sm uppercase tracking-wider transition-colors flex items-center justify-center">
              Shop All Tools <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2" />
            </button>
            <button className="bg-transparent border-2 border-white hover:bg-white hover:text-slate-900 text-white font-bold py-4 px-8 rounded-sm uppercase tracking-wider transition-colors">
              Find Your Kit
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSection;